import type { CartItem } from '../createCartItemsStore';
import { isOnProductionOnly } from '#lib/utils/env/isOnProductionOnly/isOnProductionOnly.js';
import { page } from '$app/state';
import { track } from '$global/utils/track';

export const tagAddToCart = (cartItem: Omit<CartItem, 'quantity'>) => {
	const { pathname } = page.url ?? {};
	if (
		pathname?.startsWith('/primary') &&
		!pathname.startsWith('/primary/application-preferences')
	) {
		return;
	}

	if (window.fbq) {
		try {
			const content = {
				currency: cartItem.currency?.toLowerCase(),
				value: cartItem.price,
				content_type: 'product',
				external_id: cartItem.entityId,
				contents: [
					{
						id: cartItem.sku,
						quantity: 1,
					},
				],
			};

			const ids = {
				eventID: cartItem.entityId,
				user_data: {
					external_id: cartItem.entityId,
				},
			};

			window.fbq('track', 'AddToCart', content, ids);
			track('FBQ_ADD_TO_CART', { content, ids });
		} catch (e) {
			console.error('addToCart: cannot send fbq event', e);
		}
	}

	if (isOnProductionOnly()) {
		if (window.ttq) {
			window.ttq.track('AddToCart', {
				value: cartItem.price,
				currency: cartItem.currency,
				content_type: 'product',
				contents: [
					{
						content_id: cartItem.entityId,
						content_name: cartItem.name,
						quantity: 1,
						price: cartItem.price,
					},
				],
			});
		}

		if (window.gtag) {
			window.gtag('event', 'add_to_cart', {
				value: cartItem.price,
				currency: cartItem.currency,
				items: [
					{
						item_id: cartItem.entityId,
						item_name: cartItem.name,
						price: cartItem.price,
						quantity: 1,
					},
				],
			});
		}

		if (window.twq) {
			window.twq('event', 'tw-o5kd6-oegvq', {
				value: cartItem.price,
				currency: cartItem.currency,
				contents: [
					{
						content_id: cartItem.entityId,
						content_name: cartItem.name,
						content_price: cartItem.price,
						num_items: 1,
						quantity: 1,
						content_group_id: cartItem.groupId,
					},
				],
			});
		}
	}
};
